import { Flex } from 'shared/ui/flex';
import { Typography, withTypographyContainer } from 'shared/ui/typography';
import { InputTextContainer, MarginBottom } from '../styles';
import { InputNumber } from 'shared/ui/Inputs/inputNumber';
import { FC } from 'react';
import { OrderGuestsFilterProps } from '../types';

export const OrderGuestsFilter: FC<OrderGuestsFilterProps> = ({
	guestsCountStart,
	guestsCountEnd,
	changeParticipantsStart,
	changeParticipantsEnd,
}) => {
  const Label = withTypographyContainer(Typography);

	return (
		<MarginBottom>
			<Label colorVariant={'main'} isBold={true} whiteSpace="nowrap">
				Количество гостей
			</Label>
			<Flex $gap="5px" $alignItems="center">
				<InputTextContainer>
					<InputNumber
						defaultValue={guestsCountStart}
						onChange={changeParticipantsStart}
					/>
				</InputTextContainer>
				<Typography mode={'large'}>—</Typography>
				<InputTextContainer>
					<InputNumber
						onChange={changeParticipantsEnd}
						defaultValue={guestsCountEnd}
					/>
				</InputTextContainer>
			</Flex>
		</MarginBottom>
	);
};
